function initializeClientSlider(slidesPerView = 2) {
  if (typeof window.clientSlider !== 'undefined') {
    window.clientSlider.destroy();
  }

  const clientSlider = new Swiper('.swiper', {
    slidesPerView,
    spaceBetween: 30,
    loop: true,
    autoplay: {
      delay: 3000,
    },
  });

  window.clientSlider = clientSlider;
}

window.addEventListener('DOMContentLoaded', () => {
  initializeClientSlider();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeClientSlider(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeClientSlider(document, true));
}
